import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Sparkles, Megaphone, MapPin, Palette, Users, BarChart3,
  Radio, Handshake, Settings, LogOut, Wrench, Tag, Target, Zap, Gift, Clapperboard,
  Inbox, Building2, Briefcase, ShieldCheck, UserCog, X, ScrollText, Users2, ListChecks,
  MoreHorizontal, Search, Plus, ChevronDown, ChevronsLeft, ChevronsRight, Menu, Star, Clock, Hand, KeyRound, Monitor, Store, Bell, Download, Activity, DollarSign, MessageSquare, Package, ScanLine, UserCheck, Rocket, TrendingUp, Mic2, Scale, Globe, Boxes, CalendarDays, Receipt, Wand2, Gauge, Tv, Vote, Newspaper, CheckCircle2, ArrowRight,
} from "lucide-react";
import { SrLogo } from "./Chrome";
import { auth, actAs } from "../../lib/api";
import { sr } from "../../lib/sr";
import { timeAgo } from "../../lib/timeAgo";
import { useCurrency } from "../../lib/useCurrency";
import { Navigate } from "react-router-dom";
import SrCopilot from "./Copilot";

// One master map of every destination; nav configs reference these by key.
const D = {
  home: { to: "/app", label: "Home", icon: LayoutDashboard, end: true },
  dashboard: { to: "/app/dashboard", label: "Dashboard", icon: Boxes },
  inbox: { to: "/app/inbox", label: "Inbox", icon: Inbox },
  clients: { to: "/app/admin/clients", label: "Clients", icon: Building2 },
  myClients: { to: "/app/my-clients", label: "My Clients", icon: Users },
  liveCampaigns: { to: "/app/admin/live-campaigns", label: "Live Campaigns", icon: Radio },
  queue: { to: "/app/admin/queue", label: "Assisted Queue", icon: Zap },
  work: { to: "/app/work", label: "Work Queue", icon: Hand },
  myaccess: { to: "/app/my-access", label: "My Access", icon: KeyRound },
  opsDigital: { to: "/app/ops/digital", label: "Digital Ops", icon: Monitor },
  opsRadio: { to: "/app/ops/radio", label: "Radio Ops", icon: Radio },
  portal: { to: "/app/portal", label: "Client Portal", icon: Store },
  overdue: { to: "/app/admin/overdue", label: "Overdue Approvals", icon: Bell },
  importClient: { to: "/app/admin/import", label: "Import Client", icon: Download },
  workload: { to: "/app/admin/workload", label: "Team & Capacity", icon: Users2 },
  users: { to: "/app/admin/users", label: "Users", icon: UserCog },
  roles: { to: "/app/admin/roles", label: "Roles & Permissions", icon: ShieldCheck },
  goLive: { to: "/app/admin/go-live", label: "Go-Live Approvals", icon: Rocket },
  activity: { to: "/app/admin/activity", label: "Activity", icon: ScrollText },
  growth: { to: "/app/growth-plan", label: "Growth Plan", icon: Sparkles },
  autopilot: { to: "/app/autopilot", label: "Autopilot", icon: Zap },
  campaigns: { to: "/app/campaigns", label: "Campaigns", icon: Megaphone },
  locations: { to: "/app/locations", label: "Locations", icon: MapPin },
  competitors: { to: "/app/competitors", label: "Competitor Studio", icon: Target },
  creative: { to: "/app/creative", label: "Creative", icon: Palette },
  catalog: { to: "/app/catalog", label: "Catalog", icon: Package },
  video: { to: "/app/video", label: "Video Studio", icon: Clapperboard },
  offers: { to: "/app/offers", label: "Offer Studio", icon: Tag },
  scanRedeem: { to: "/app/offers/redeem", label: "Scan & Redeem", icon: ScanLine },
  loyalty: { to: "/app/loyalty", label: "Loyalty Loop", icon: Gift },
  leads: { to: "/app/leads", label: "Lead Concierge", icon: MessageSquare },
  franchise: { to: "/app/franchise", label: "Stores & Franchise", icon: Store },
  agency: { to: "/app/agency", label: "Agency", icon: Briefcase },
  customers: { to: "/app/customers", label: "Customers", icon: Users },
  results: { to: "/app/results", label: "Performance", icon: BarChart3 },
  radio: { to: "/app/radio", label: "Radio Sync", icon: Radio },
  services: { to: "/app/services", label: "Services", icon: Handshake },
  settings: { to: "/app/settings", label: "Settings", icon: Settings },
  ops: { to: "/ops", label: "Operations", icon: Wrench },
  trackingHealth: { to: "/app/tracking-health", label: "Tracking Health", icon: Activity },
  promotions: { to: "/app/admin/promotions", label: "Promotions & Credits", icon: Gift },
  credits: { to: "/app/ai-ad", label: "SmartReach Credits", icon: Gift },
  aiAd: { to: "/app/ai-ad", label: "AI Ad Creation", icon: Wand2 },
  metaAds: { to: "/app/meta-ads", label: "Meta Ads", icon: Megaphone },
  googleAds: { to: "/app/google-ads", label: "Google Search", icon: Search },
  funasia: { to: "/app/funasia", label: "FunAsia Packages", icon: Package },
  sales: { to: "/app/sales", label: "Sales CRM", icon: Briefcase },
  spendCaps: { to: "/app/admin/spend-caps", label: "Spend Caps", icon: DollarSign },
  opsInbox: { to: "/app/admin/ops-tasks", label: "Ops Inbox", icon: Inbox },
  clientApprovals: { to: "/app/admin/client-approvals", label: "Client Approvals", icon: UserCheck },
  radioStations: { to: "/app/admin/radio-audiences", label: "Radio Stations", icon: Radio },
  radioConsole: { to: "/app/admin/radio-flights", label: "Radio Flights", icon: Radio },
  clientFlights: { to: "/app/radio-flights", label: "My Radio Flights", icon: Radio },
  more: { to: "/app/more", label: "More", icon: MoreHorizontal },
  successStory: { to: "/app/success-story", label: "Success Story", icon: TrendingUp },
  videoLibrary: { to: "/app/video/library", label: "Voice & Presenters", icon: Mic2 },
  settlements: { to: "/app/settlements", label: "Settlements", icon: Scale },
  domains: { to: "/app/domains", label: "White-label Domains", icon: Globe },
  adminDomains: { to: "/app/admin/domains", label: "Custom Domains", icon: Globe },
  marginReport: { to: "/app/admin/margin-report", label: "Margin Report", icon: DollarSign },
  pricingEngine: { to: "/app/admin/pricing", label: "Pricing Engine", icon: Tag },
  retargeting: { to: "/app/retargeting", label: "Retargeting", icon: Target },
  inventoryGuard: { to: "/app/inventory-guard", label: "Inventory Guard", icon: Boxes },
  releaseCalendar: { to: "/app/release-calendar", label: "Release Calendar", icon: CalendarDays },
  salesReport: { to: "/app/sales-report", label: "Verified Sales", icon: Receipt },
  dynamicAds: { to: "/app/dynamic-ads", label: "Dynamic Product Ads", icon: Wand2 },
  budgetRecs: { to: "/app/budget-recommendations", label: "Budget Recommendations", icon: Gauge },
  doohAds: { to: "/app/dooh", label: "DOOH Ads", icon: Tv },
  chatgptAds: { to: "/app/chatgpt-ads", label: "ChatGPT Ads", icon: MessageSquare },
  movieStudio: { to: "/app/movie-studio", label: "Movie Studio", icon: Clapperboard },
  audiences: { to: "/app/audiences", label: "Audiences", icon: Target },
  customerLists: { to: "/app/customer-lists", label: "Customer Lists", icon: Users },
  politicalStudio: { to: "/app/political-studio", label: "Political Studio", icon: Vote },
  proposals: { to: "/app/proposals", label: "Proposal Studio", icon: ScrollText },
  easy: { to: "/app/easy", label: "Build a campaign", icon: Rocket },
  whatsNew: { to: "/app/whats-new", label: "What's New", icon: Newspaper },
};

// Easy mode: <= 5 primary items per persona, then a single "More".
const EASY = {
  platform_admin: ["easy", "home", "clients", "queue", "results"],
  internal_staff: ["easy", "home", "inbox", "campaigns", "results"],
  client: ["easy", "dashboard", "campaigns", "results", "inbox"],
  sales: ["proposals"],
};

// Pro mode: grouped, contextual. Admin/ops groups added by persona below.
const PRO_GROUPS = [
  { name: "Portfolio", items: ["home", "inbox", "results", "salesReport", "successStory", "whatsNew", "myaccess"] },
  { name: "Clients", items: ["myClients", "clients", "liveCampaigns", "franchise", "agency", "domains", "customers", "portal"] },
  { name: "Sales", items: ["sales"] },
  { name: "Projects & Campaigns", items: ["growth", "autopilot", "campaigns", "work"] },
  { name: "Digital Operations", items: ["opsDigital", "audiences", "customerLists", "politicalStudio", "metaAds", "googleAds", "retargeting", "inventoryGuard", "dynamicAds", "budgetRecs", "doohAds", "chatgptAds", "locations", "competitors", "leads"] },
  { name: "Radio Operations", items: ["opsRadio", "radioConsole", "radio", "funasia"] },
  { name: "Creative & Offers", items: ["catalog", "releaseCalendar", "movieStudio", "creative", "video", "videoLibrary", "aiAd", "offers", "scanRedeem", "loyalty"] },
];
const PRO_ADMIN = { name: "Administration", items: ["clientApprovals", "opsInbox", "radioStations", "radioConsole", "promotions", "importClient", "spendCaps", "marginReport", "pricingEngine", "settlements", "adminDomains", "users", "roles", "overdue", "activity", "trackingHealth", "services", "settings"] };
// Client persona sees a trimmed, non-internal set.
const CLIENT_GROUPS = [
  { name: "Portfolio", items: ["portal", "dashboard", "home", "inbox", "results", "salesReport", "successStory", "whatsNew"] },
  { name: "Projects & Campaigns", items: ["campaigns", "audiences", "customerLists", "franchise", "metaAds", "googleAds", "retargeting", "inventoryGuard", "dynamicAds", "budgetRecs", "doohAds", "chatgptAds", "funasia", "clientFlights"] },
  { name: "Creative & Offers", items: ["catalog", "releaseCalendar", "movieStudio", "creative", "aiAd", "offers", "scanRedeem", "loyalty", "videoLibrary"] },
  { name: "Account", items: ["credits", "myaccess", "settlements", "domains", "settings"] },
];

// A salesperson sees ONLY the Proposal Studio — no client consoles, ops, secrets or pricing tools.
const SALES_GROUPS = [
  { name: "Sales", items: ["proposals"] },
  { name: "Portfolio", items: ["whatsNew"] },
];

const testid = (key) => `nav-${key}`;

// One-time, after-first-signup prompt. Mode is personal and switchable anytime — it never
// changes permissions or agency settings, and the separate "Who are you growing?" question stays.
function ModePrompt({ onChoose }) {
  return (
    <div data-testid="mode-prompt" style={{ position: "fixed", inset: 0, zIndex: 80, background: "rgba(16,24,40,.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div className="sr-card" style={{ width: "100%", maxWidth: 640, padding: 28 }}>
        <h2 style={{ fontSize: 24, color: "var(--navy)", margin: 0, textAlign: "center" }}>How would you like to build your campaigns?</h2>
        <p className="sr-muted" style={{ textAlign: "center", marginTop: 8 }}>You can switch anytime.</p>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginTop: 20 }}>
          <button type="button" onClick={() => onChoose("easy")} data-testid="mode-prompt-easy"
            style={{ textAlign: "left", border: "2px solid var(--blue)", background: "var(--blue-light)", borderRadius: 14, padding: 20, cursor: "pointer" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}><Sparkles size={18} style={{ color: "var(--blue)" }} /><strong style={{ fontSize: 17, color: "var(--navy)" }}>Easy</strong></div>
            <div style={{ fontSize: 13, color: "var(--navy)", marginTop: 4, fontWeight: 700 }}>Guided by AI</div>
            <p className="sr-muted" style={{ fontSize: 13, marginTop: 8, lineHeight: 1.5 }}>Set your budget and goal, review a recommended plan, add your creative and launch.</p>
          </button>
          <button type="button" onClick={() => onChoose("pro")} data-testid="mode-prompt-pro"
            style={{ textAlign: "left", border: "2px solid var(--border)", background: "#fff", borderRadius: 14, padding: 20, cursor: "pointer" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}><Wrench size={18} style={{ color: "var(--navy)" }} /><strong style={{ fontSize: 17, color: "var(--navy)" }}>Pro</strong></div>
            <div style={{ fontSize: 13, color: "var(--navy)", marginTop: 4, fontWeight: 700 }}>Full campaign control</div>
            <p className="sr-muted" style={{ fontSize: 13, marginTop: 8, lineHeight: 1.5 }}>Configure audiences, channels, targeting, allocations and advanced settings.</p>
          </button>
        </div>
      </div>
    </div>
  );
}

function pushRecent(c) {
  try {
    const cur = JSON.parse(localStorage.getItem("sr_recent_clients") || "[]").filter((x) => x.tenant_id !== c.id);
    cur.unshift({ tenant_id: c.id, name: c.name });
    localStorage.setItem("sr_recent_clients", JSON.stringify(cur.slice(0, 5)));
  } catch { /* ignore */ }
}

function SwitchRow({ c, tid, onPick }) {
  return (
    <button onClick={() => onPick({ id: c.tenant_id || c.id, name: c.name })} data-testid={tid}
      style={{ display: "flex", alignItems: "center", gap: 8, width: "100%", textAlign: "left", background: "none",
        border: "none", padding: "8px 10px", borderRadius: 8, cursor: "pointer", fontSize: 13, color: "var(--navy)" }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F5F8")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "none")}>
      <Building2 size={14} style={{ color: "var(--muted)", flexShrink: 0 }} />
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.name}</span>
    </button>
  );
}

function ClientSwitcher({ user }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [clients, setClients] = useState(null);
  const [q, setQ] = useState("");
  const acting = actAs.get();
  useEffect(() => { sr.adminTenants().then((r) => setClients(r.tenants || [])).catch(() => setClients([])); }, []);

  const recents = (() => { try { return JSON.parse(localStorage.getItem("sr_recent_clients") || "[]"); } catch { return []; } })();
  const email = (user?.email || "").toLowerCase();
  const list = clients || [];
  const mine = list.filter((c) => (c.owner_email || "").toLowerCase() === email || (c.assigned_manager_email || "").toLowerCase() === email);
  const s = q.trim().toLowerCase();
  const filtered = !s ? list : list.filter((c) =>
    (c.name || "").toLowerCase().includes(s) || (c.owner_email || "").toLowerCase().includes(s));

  const pick = async (c) => {
    actAs.set(c.id, c.name); pushRecent(c);
    try { await sr.adminActAs(c.id); } catch { /* best-effort */ }
    window.location.reload();
  };
  const reset = () => { actAs.clear(); window.location.reload(); };
  const addClient = () => { setOpen(false); nav("/app/admin/clients?new=1"); };

  return (
    <div style={{ position: "relative", minWidth: 0 }} data-testid="client-switcher-wrap">
      <button onClick={() => setOpen((v) => !v)} data-testid="client-switcher-btn"
        style={{ display: "flex", alignItems: "center", gap: 8, background: "#fff", border: "1px solid var(--border)",
          borderRadius: 10, padding: "7px 12px", cursor: "pointer", maxWidth: 320, fontWeight: 700, color: "var(--navy)" }}>
        <Building2 size={15} style={{ color: "var(--muted)", flexShrink: 0 }} />
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 13 }}>
          {acting?.name || "My workspace"}
        </span>
        <ChevronDown size={15} style={{ color: "var(--muted)", flexShrink: 0 }} />
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 40 }} />
          <div data-testid="client-switcher-panel" style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, zIndex: 41,
            width: 340, maxHeight: 460, overflow: "hidden", background: "#fff", border: "1px solid var(--border)",
            borderRadius: 12, boxShadow: "0 12px 32px rgba(16,24,40,.16)", display: "flex", flexDirection: "column" }}>
            <div style={{ padding: 10, borderBottom: "1px solid var(--border)", display: "flex", gap: 8 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, flex: 1, background: "#F3F5F8", borderRadius: 8, padding: "6px 10px" }}>
                <Search size={14} style={{ color: "var(--muted)" }} />
                <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search clients"
                  data-testid="client-switcher-search"
                  style={{ border: "none", background: "none", outline: "none", fontSize: 13, width: "100%" }} />
              </div>
              <button onClick={addClient} data-testid="client-switcher-add" className="sr-btn sr-btn-primary sr-btn-sm">
                <Plus size={14} /> Add
              </button>
            </div>
            <div style={{ overflowY: "auto", padding: 8 }}>
              <button onClick={reset} data-testid="client-switcher-workspace"
                style={{ display: "flex", alignItems: "center", gap: 8, width: "100%", textAlign: "left", background: acting ? "none" : "var(--blue-light)",
                  border: "none", padding: "8px 10px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 700, color: "var(--navy)" }}>
                <LayoutDashboard size={14} /> My workspace
              </button>
              {clients === null ? (
                <p className="sr-muted" style={{ fontSize: 12, padding: 10 }}>Loading…</p>
              ) : (
                <>
                  {!s && recents.length > 0 && (
                    <div data-testid="client-recent">
                      <div className="sr-switch-head"><Clock size={11} /> Recent</div>
                      {recents.map((c) => <SwitchRow key={"r" + c.tenant_id} c={c} tid={`recent-${c.tenant_id}`} onPick={pick} />)}
                    </div>
                  )}
                  {!s && mine.length > 0 && (
                    <div data-testid="client-my">
                      <div className="sr-switch-head"><Star size={11} /> My clients</div>
                      {mine.map((c) => <SwitchRow key={"m" + c.id} c={c} tid={`my-${c.id}`} onPick={pick} />)}
                    </div>
                  )}
                  <div data-testid="client-all">
                    <div className="sr-switch-head">{s ? "Results" : "All clients"} · {filtered.length}</div>
                    {filtered.slice(0, 60).map((c) => <SwitchRow key={c.id} c={c} tid={`client-opt-${c.id}`} onPick={pick} />)}
                    {filtered.length === 0 && <p className="sr-muted" style={{ fontSize: 12, padding: 10 }}>No matching clients.</p>}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

function SideLink({ d, dkey, badge }) {
  return (
    <NavLink to={d.to} end={d.end} data-testid={testid(dkey)} title={d.label}
      className={({ isActive }) => `sr-side-link ${isActive ? "active" : ""}`}>
      <d.icon size={18} /> <span className="sr-side-label">{d.label}</span>
      {badge > 0 && (
        <span data-testid={`nav-badge-${dkey}`} style={{ marginLeft: "auto", background: "#C0362C", color: "#fff",
          borderRadius: 999, fontSize: 10, fontWeight: 800, minWidth: 16, height: 16, display: "inline-flex",
          alignItems: "center", justifyContent: "center", padding: "0 5px" }}>{badge}</span>
      )}
    </NavLink>
  );
}

function NavGroup({ group, open, onToggle, badges, hasActive }) {
  const slug = group.name.replace(/[^a-z0-9]+/gi, "-").toLowerCase();
  const groupTotal = (group.items || []).reduce((a, k) => a + (Number(badges?.[k]) || 0), 0);
  return (
    <div className="sr-nav-section">
      <button type="button" onClick={onToggle} data-testid={`nav-group-${slug}`}
        className={`sr-nav-group ${open ? "open" : ""}`} aria-expanded={open}>
        <span>{group.name}</span>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          {!open && hasActive && <span className="sr-nav-group-dot" data-testid={`nav-group-active-${slug}`} title="Your current page is in this section" />}
          {!open && groupTotal > 0 && (
            <span data-testid={`nav-group-badge-${slug}`} style={{ background: "#C0362C", color: "#fff", borderRadius: 999,
              fontSize: 10, fontWeight: 800, minWidth: 16, height: 16, display: "inline-flex", alignItems: "center",
              justifyContent: "center", padding: "0 5px" }}>{groupTotal}</span>
          )}
          <ChevronDown size={13} className="sr-nav-group-caret" style={{ transform: open ? "rotate(0deg)" : "rotate(-90deg)" }} />
        </span>
      </button>
      {open && (
        <div className="sr-nav-group-items">
          {group.items.map((k) => D[k] ? <SideLink key={k} d={D[k]} dkey={k} badge={badges?.[k]} /> : null)}
        </div>
      )}
    </div>
  );
}

const UPD_TAG = {
  Feature: { cls: "sr-badge-blue", label: "New feature" },
  Improvement: { cls: "sr-badge-gold", label: "Improvement" },
  Fix: { cls: "sr-badge-green", label: "Fix" },
};

function UpdatesPopup({ items, onClose, onDismissAll }) {
  const nav = useNavigate();
  const unread = (items || []).filter((u) => !u.read);
  const top = (unread.length ? unread : items || []).slice(0, 4);
  const openFeature = (u) => { onClose(); if (u.link?.web) nav(u.link.web); };
  return (
    <div data-testid="updates-popup" onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 85, background: "rgba(10,18,28,.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div className="sr-card" onClick={(e) => e.stopPropagation()} style={{ width: "100%", maxWidth: 560, padding: 24, maxHeight: "86vh", overflowY: "auto" }}>
        <div className="sr-eyebrow" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><Newspaper size={13} /> What's New</div>
        <h2 style={{ fontSize: 22, marginTop: 6 }}>Here's what we've shipped</h2>
        <p className="sr-muted" style={{ fontSize: 13, marginTop: 4 }}>New since you were last here.</p>
        <div style={{ display: "grid", gap: 12, marginTop: 16 }}>
          {top.map((u) => {
            const tag = UPD_TAG[u.tag] || { cls: "sr-badge-gray", label: u.tag || "Update" };
            return (
              <div key={u.id || u.seq} data-testid={`updates-popup-item-${u.seq}`} style={{ border: "1px solid var(--border)", borderRadius: 12, padding: 14 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  <span className={`sr-badge ${tag.cls}`} style={{ fontSize: 10 }}>{tag.label}</span>
                  <span className="sr-muted" style={{ fontSize: 11 }}>{timeAgo(u.date)}</span>
                </div>
                <strong style={{ fontSize: 14, color: "var(--navy)", display: "block", marginTop: 6 }}>{u.title}</strong>
                {u.summary && <p className="sr-muted" style={{ fontSize: 13, marginTop: 4, lineHeight: 1.5 }}>{u.summary}</p>}
                {u.link?.web && (
                  <button type="button" className="sr-link-btn" data-testid={`updates-popup-go-${u.seq}`} onClick={() => openFeature(u)}
                    style={{ marginTop: 8, display: "inline-flex", alignItems: "center", gap: 4, background: "none", border: "none", color: "var(--blue)", fontWeight: 700, fontSize: 13, cursor: "pointer", padding: 0 }}>
                    {u.link.label || "Open"} <ArrowRight size={13} />
                  </button>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 18 }}>
          <button type="button" className="sr-btn sr-btn-ghost sr-btn-sm" data-testid="updates-popup-view-all"
            onClick={() => { onClose(); nav("/app/whats-new"); }}>See all updates</button>
          <button type="button" className="sr-btn sr-btn-primary sr-btn-sm" data-testid="updates-popup-dismiss" onClick={onDismissAll}>
            <CheckCircle2 size={14} /> Got it
          </button>
        </div>
      </div>
    </div>
  );
}

function RegionBadge() {
  const cur = useCurrency();
  if (!cur.currency) return null;
  const local = (cur.currency || "USD") !== "USD";
  return (
    <span data-testid="region-badge" title={`Market: ${cur.region_label || cur.region || "United States"}`}
      style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, fontWeight: 800,
        padding: "5px 10px", borderRadius: 999, border: "1px solid var(--border)",
        background: local ? "#EAF2FF" : "#F3F5F8", color: local ? "var(--blue)" : "var(--navy)" }}>
      <span style={{ fontSize: 13 }}>{cur.flag || "🌐"}</span> {cur.currency}
    </span>
  );
}

function NotificationBell({ enabled }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const load = () => { if (!enabled) return; sr.notifications().then((r) => { setItems(r.notifications || []); setUnread(r.unread || 0); }).catch(() => {}); };
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
  const openItem = async (n) => {
    if (!n.read) { try { await sr.markNotifRead(n.id); } catch (e) { /* noop */ } }
    setOpen(false);
    if (n.link) nav(n.link);
    load();
  };
  const readAll = async () => { try { await sr.markAllNotifRead(); } catch (e) { /* noop */ } load(); };
  return (
    <div style={{ position: "relative" }}>
      <button className="sr-btn sr-btn-ghost sr-btn-sm" onClick={() => setOpen((o) => !o)} data-testid="notif-bell" style={{ position: "relative" }}>
        <Bell size={16} />
        {unread > 0 && (
          <span data-testid="notif-unread" style={{ position: "absolute", top: -4, right: -4, background: "#C0362C", color: "#fff",
            borderRadius: 999, fontSize: 10, fontWeight: 800, minWidth: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 4px" }}>{unread}</span>
        )}
      </button>
      {open && (
        <div data-testid="notif-panel" style={{ position: "absolute", right: 0, top: "calc(100% + 8px)", width: 340, maxHeight: 420, overflowY: "auto",
          background: "#fff", border: "1px solid var(--border)", borderRadius: 12, boxShadow: "0 12px 32px rgba(16,24,40,.16)", zIndex: 50, padding: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 8px" }}>
            <strong style={{ color: "var(--navy)", fontSize: 14 }}>Notifications</strong>
            {unread > 0 && <button className="sr-btn sr-btn-ghost sr-btn-sm" onClick={readAll} data-testid="notif-read-all">Mark all read</button>}
          </div>
          {items.length === 0 ? (
            <p className="sr-muted" style={{ fontSize: 13, padding: "10px 8px" }} data-testid="notif-empty">You are all caught up.</p>
          ) : items.map((n) => (
            <button key={n.id} onClick={() => openItem(n)} data-testid={`notif-${n.id}`}
              style={{ display: "block", width: "100%", textAlign: "left", border: "none", cursor: "pointer",
                background: n.read ? "transparent" : "var(--blue-light)", borderRadius: 8, padding: "10px 10px", marginTop: 4 }}>
              <div style={{ fontSize: 13, color: "var(--navy)", fontWeight: n.read ? 500 : 700 }}>{n.text}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function AppShell() {
  const nav = useNavigate();
  const loc = useLocation();
  const user = auth.getUser();
  const isCounter = user && user.role === "counter_staff";
  const isSales = user && user.role === "salesperson";
  const isStaff = user && ["admin", "super_admin", "campaign_manager", "compliance_reviewer"].includes(user.role);
  const isAdmin = user && ["admin", "super_admin"].includes(user.role);
  const persona = isAdmin ? "platform_admin" : isSales ? "sales" : isStaff ? "internal_staff" : "client";
  const acting = actAs.get();
  const [mode, setMode] = useState("pro");
  const [showModePrompt, setShowModePrompt] = useState(false);
  const tenantScoped = !!acting || persona === "client";

  useEffect(() => {
    if (!tenantScoped) return;
    sr.getPrefs().then((p) => {
      setMode(p.workspace_mode || "pro");
      // One-time "how would you like to build?" prompt after first signup. Never re-asked.
      if (!p.mode_prompted && persona === "client") setShowModePrompt(true);
    }).catch(() => {});
  }, [tenantScoped, persona]);
  // Adaptive catalog label (Movies & Releases / Products & Collections / Services & Offers / Events).
  const [, setCatalogLabel] = useState(null);
  useEffect(() => {
    if (!tenantScoped) return;
    sr.businessModel().then((b) => { if (b?.catalog_label) { D.catalog.label = b.catalog_label; setCatalogLabel(b.catalog_label); } }).catch(() => {});
  }, [tenantScoped]);
  // Switching mode never changes permissions — it only changes this user's view of the SAME work.
  const changeMode = (m) => {
    setMode(m);
    sr.setPrefs({ workspace_mode: m }).catch(() => {});
    if (m === "easy") nav("/app/easy");
    else if (loc.pathname === "/app/easy") nav("/app/growth-plan");
  };
  const chooseMode = (m) => {
    setMode(m); setShowModePrompt(false);
    sr.setPrefs({ workspace_mode: m, mode_prompted: true }).catch(() => {});
    if (m === "easy") nav("/app/easy");
  };

  // Live unread count for the staff Ops Inbox (partner-intro + connector setup requests).
  const [opsCount, setOpsCount] = useState(0);
  useEffect(() => {
    if (!isAdmin) return;
    let stop = false;
    const load = () => sr.adminOpsTasks("open").then((r) => { if (!stop) setOpsCount(r.open_count || 0); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { stop = true; clearInterval(t); };
  }, [isAdmin]);
  const badges = { opsInbox: opsCount };

  // In-app update log ("What's New"): unread badge + one-time login popup announcing unseen updates.
  const [updItems, setUpdItems] = useState([]);
  const [updUnread, setUpdUnread] = useState(0);
  const [showUpdates, setShowUpdates] = useState(false);
  useEffect(() => {
    let stop = false;
    sr.getUpdates().then((r) => {
      if (stop) return;
      setUpdItems(r.updates || []);
      setUpdUnread(r.unread_count || 0);
    }).catch(() => {});
    const onChanged = (e) => setUpdUnread((e?.detail && typeof e.detail.unread === "number") ? e.detail.unread : 0);
    window.addEventListener("sr-updates-changed", onChanged);
    return () => { stop = true; window.removeEventListener("sr-updates-changed", onChanged); };
  }, []);
  // Announce unseen updates once per session — never on top of the one-time build-mode prompt,
  // and never re-pop when the unread count later changes (e.g. dismissing items on the page).
  const poppedRef = React.useRef(false);
  useEffect(() => {
    const deepLink = typeof window !== "undefined" && /[?&]reclaim=1\b/.test(window.location.search);
    if (!poppedRef.current && !showModePrompt && !deepLink && updUnread > 0) { poppedRef.current = true; setShowUpdates(true); }
  }, [showModePrompt, updUnread]);
  const hideUpdates = () => setShowUpdates(false);
  const dismissUpdates = () => {
    setShowUpdates(false);
    sr.markUpdatesSeen().then(() => setUpdUnread(0)).catch(() => setUpdUnread(0));
  };
  badges.whatsNew = updUnread;

  const logout = () => { auth.logout(); nav("/login"); };
  const exitActAs = () => { actAs.clear(); window.location.assign("/app/admin/clients"); };

  // Staff have no personal workspace. Admin-global routes work without a client;
  // every other /app/* route is tenant-scoped and shows a friendly "pick a client" prompt.
  const ADMIN_GLOBAL = ["/app/admin", "/app/my-clients", "/app/agency", "/app/domains", "/app/portal", "/app/work", "/app/ops", "/app/my-access", "/app/more", "/app/services", "/app/customers", "/app/sales", "/app/proposals", "/app/tracking-health", "/app/act-as", "/app/whats-new", "/app/admin/pricing"];
  const needClient = isStaff && !acting && loc.pathname.startsWith("/app")
    && loc.pathname !== "/app" && !ADMIN_GLOBAL.some((p) => loc.pathname.startsWith(p));

  // Pro-mode groups by persona. Go-Live Approvals is super-admin only.
  const adminGroup = { ...PRO_ADMIN, items: [...(user?.role === "super_admin" ? ["goLive"] : []), ...PRO_ADMIN.items] };
  // Admin & super-admin get a Proposal Studio shortcut right under the Sales group.
  const proGroups = isAdmin
    ? PRO_GROUPS.map((g) => (g.name === "Sales" ? { ...g, items: ["proposals", ...g.items] } : g))
    : PRO_GROUPS;
  const groups = persona === "client" ? CLIENT_GROUPS
    : persona === "sales" ? SALES_GROUPS
    : [...proGroups, ...(isAdmin ? [adminGroup] : []), ...(isStaff ? [{ name: "Operations", items: ["ops"] }] : [])];
  const easyKeys = EASY[persona] || EASY.client;
  const easyGroups = [{ name: "Menu", items: [...easyKeys, "more"] }];
  const navGroups = mode === "easy" ? easyGroups : groups;

  // Accordion nav: exactly one category open at a time. Defaults to "Portfolio" on first login,
  // otherwise restores the last category the user had open (persisted). Opening one closes the rest.
  const defaultGroup = (navGroups.find((g) => g.name === "Portfolio") || navGroups[0] || {}).name || null;
  const [openGroup, setOpenGroup] = useState(() => {
    try {
      const saved = localStorage.getItem("sr_nav_open_group");
      return saved !== null ? (saved || null) : defaultGroup;
    } catch { return defaultGroup; }
  });
  const groupNames = navGroups.map((g) => g.name);
  const effectiveOpen = (openGroup && !groupNames.includes(openGroup)) ? defaultGroup : openGroup;
  const toggleGroup = (name) => setOpenGroup((prev) => {
    const next = prev === name ? null : name;
    try { localStorage.setItem("sr_nav_open_group", next || ""); } catch { /* ignore */ }
    return next;
  });
  const displayOpen = (name) => effectiveOpen === name;

  // Which group contains the current route — surfaces an amber dot on a collapsed section
  // so you always know where your current page lives.
  const groupHasActive = (g) => (g.items || []).some((k) => {
    const d = D[k];
    if (!d) return false;
    return d.end ? loc.pathname === d.to : (loc.pathname === d.to || loc.pathname.startsWith(d.to + "/"));
  });

  // Readable sidebar: expanded (full labels) vs compact (narrower, same 15px font). Persisted.
  const [sidebarMode, setSidebarMode] = useState(() => {
    try { return localStorage.getItem("sr_sidebar_mode") === "compact" ? "compact" : "expanded"; } catch { return "expanded"; }
  });
  const toggleSidebar = () => setSidebarMode((m) => {
    const next = m === "compact" ? "expanded" : "compact";
    try { localStorage.setItem("sr_sidebar_mode", next); } catch { /* ignore */ }
    return next;
  });
  // Mobile drawer (<=900px): closed by default, closes on navigation.
  const [drawerOpen, setDrawerOpen] = useState(false);
  useEffect(() => { setDrawerOpen(false); }, [loc.pathname]);

  if (isCounter) return <Navigate to="/counter" replace />;
  if (isSales && (loc.pathname === "/app" || loc.pathname === "/app/")) return <Navigate to="/app/proposals" replace />;

  return (
    <div className="sr-root">
      <div className="sr-app">
        <div className={`sr-side-backdrop ${drawerOpen ? "open" : ""}`} onClick={() => setDrawerOpen(false)} data-testid="sidebar-backdrop" />
        <aside className={`sr-sidebar ${sidebarMode === "compact" ? "compact" : ""} ${drawerOpen ? "open" : ""}`} data-testid="app-sidebar" data-mode={sidebarMode}>
          <div className="sr-side-head">
            <SrLogo light />
            <button type="button" onClick={toggleSidebar} className="sr-side-collapse" data-testid="sidebar-collapse-toggle"
              aria-label={sidebarMode === "compact" ? "Expand sidebar" : "Collapse sidebar"}
              title={sidebarMode === "compact" ? "Expand sidebar" : "Collapse sidebar"}>
              {sidebarMode === "compact" ? <ChevronsRight size={18} /> : <ChevronsLeft size={18} />}
            </button>
          </div>
          {navGroups.map((g) => (
            <NavGroup key={g.name} group={g} open={displayOpen(g.name)} onToggle={() => toggleGroup(g.name)} badges={badges} hasActive={groupHasActive(g)} />
          ))}
        </aside>

        <div className="sr-main">
          {acting && (
            <div data-testid="acting-as-banner" style={{
              background: "#FCF1DC", borderBottom: "1px solid #E3C878", color: "#7A5B12",
              padding: "8px 20px", display: "flex", alignItems: "center", justifyContent: "space-between",
              gap: 12, fontSize: 13, fontWeight: 600 }}>
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <ShieldCheck size={15} /> Acting as <b style={{ color: "#5C440C" }}>{acting.name || "client"}</b> — changes you make apply to this client.
              </span>
              <button onClick={exitActAs} data-testid="exit-act-as-btn"
                style={{ display: "flex", alignItems: "center", gap: 6, background: "#7A5B12", color: "#fff",
                  border: "none", borderRadius: 999, padding: "5px 12px", cursor: "pointer", fontSize: 12, fontWeight: 700 }}>
                <X size={13} /> Exit client
              </button>
            </div>
          )}
          <div className="sr-topbar">
            <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
              <button type="button" className="sr-side-mobile-toggle" onClick={() => setDrawerOpen(true)} data-testid="sidebar-mobile-toggle" aria-label="Open navigation menu" title="Menu">
                <Menu size={18} />
              </button>
              {isAdmin ? <ClientSwitcher user={user} /> : <strong style={{ color: "var(--navy)" }}>{user?.name || "Your workspace"}</strong>}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div data-testid="mode-toggle" style={{ display: "flex", background: "#EEF1F5", borderRadius: 999, padding: 3 }}>
                {["easy", "pro"].map((m) => (
                  <button key={m} onClick={() => changeMode(m)} data-testid={`mode-${m}`}
                    style={{ border: "none", cursor: "pointer", borderRadius: 999, padding: "5px 14px", fontSize: 12, fontWeight: 700,
                      textTransform: "capitalize", background: mode === m ? "#fff" : "transparent",
                      color: mode === m ? "var(--navy)" : "var(--muted)",
                      boxShadow: mode === m ? "0 1px 3px rgba(16,24,40,.12)" : "none" }}>
                    {m}
                  </button>
                ))}
              </div>
              <NotificationBell enabled={tenantScoped || isStaff} />
              {tenantScoped && <RegionBadge />}
              <button className="sr-btn sr-btn-ghost sr-btn-sm" onClick={logout} data-testid="logout-btn">
                <LogOut size={15} /> Log out
              </button>
            </div>
          </div>
          <div className="sr-content sr-fade">
            {needClient ? (
              <div className="sr-card" data-testid="shell-needs-client" style={{ textAlign: "center", padding: 48, maxWidth: 520, margin: "40px auto" }}>
                <Target size={30} style={{ color: "var(--blue)" }} />
                <h3 style={{ margin: "14px 0 4px", fontSize: 20 }}>Select a client to continue</h3>
                <p className="sr-muted" style={{ fontSize: 14 }}>This page works inside a client's workspace. Pick a client to manage, then this section will open.</p>
                <button className="sr-btn sr-btn-primary" style={{ marginTop: 14 }} onClick={() => nav("/app/admin/clients")} data-testid="shell-go-clients">
                  <Building2 size={15} /> Go to Clients
                </button>
              </div>
            ) : <Outlet />}
          </div>
        </div>
      </div>
      {showModePrompt && <ModePrompt onChoose={chooseMode} />}
      {showUpdates && <UpdatesPopup items={updItems} onClose={hideUpdates} onDismissAll={dismissUpdates} />}
      <SrCopilot />
    </div>
  );
}
